import { PATHS } from 'commons/paths';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const TransitionButton: React.FC<{
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  label?: string;
  type?: 'button' | 'submit' | 'reset';
}> = (props) => {
  const navigate = useNavigate();
  const BackToTop = useCallback(() => {
    navigate(PATHS.MYPAGE);
  }, [navigate]);

  const { t: tCommons } = useTranslationWithLang('commons');
  return (
    <button
      className={
        'text-[--c-button-border-secondary] ' +
        'bg-[--c-background] ' +
        'border-2 ' +
        'border-[--c-button-border-secondary] ' +
        'font-bold ' +
        'my-6 ' +
        'min-w-[120px] ' +
        'hover:text-[--c-button-border-secondary-hover] ' +
        'hover:bg-[--c-button-background-secondary-hover] ' +
        'hover:border-[--c-button-border-secondary-hover] ' +
        'rounded ' +
        'py-4 ' +
        'rounded-full ' +
        'focus:outline-none ' +
        'focus:ring-2 ' +
        'focus:ring-[--c-primary-color] ' +
        (props.className || '')
      }
      style={props.style}
      type={props.type ?? 'button'}
      onClick={props.onClick ? props.onClick : BackToTop}
      title={props.label ? props.label : tCommons('TU000_047')}
    >
      {props.label ? props.label : tCommons('TU000_047')}
    </button>
  );
};
